import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 20 20" focusable="false" aria-hidden="true"><path d="M0 16V4a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4Z" fill="#FFF" /><path d="M0 16V4a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4Zm1.5 0q0 1.036.732 1.768T4 18.5h12q1.036 0 1.768-.732T18.5 16V4q0-1.036-.732-1.768T16 1.5H4q-1.036 0-1.768.732T1.5 4v12Z" fillRule="evenodd" fill="#A2A2A2" /><path d="M1 18h18v.5a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1-.5-.5Z" fill="#A2A2A2" /></svg>

const TemplateFullscreen = React.forwardRef((props, ref) => {
  return (
    <IconBase name="template-fullscreen" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

TemplateFullscreen.displayName = 'IconTemplateFullscreen'

export default TemplateFullscreen
